import React, { useRef, useContext, useState } from "react";
import {
  OverlayTrigger,
  Tooltip,
  Row,
  Col,
  Form,
  Button,
  Modal,
} from "react-bootstrap";
import { Formik } from "formik";
import { get, isEmpty, union, values } from "lodash";
import {
  faPencilAlt,
  faTimes,
  faTrashAlt,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ManagePlanLayout,
  AddPlans,
  AddButton,
  CsplTable as Table,
  Link,
  DeleteWarning,
  LoaderWrapper,
} from "../../../components";
import {
  FLOW_TYPES,
  MANAGE_PLAN_ROUTES,
  getPathWithParam,
  managePlanFormNames,
  formFields,
  usDateFormat,
  getSaveMessage,
  SOURCE_CATEGORY_NAME_MAPPING,
  toFormValue,
  toApiValue,
  getAdvancedPathWithParam,
  getNumber,
} from "../../../utils";
import { useDeepEffect, useRouterParams, useRequest } from "../../../abstracts";
import AllocationRulesForm from "./AllocationRulesForm";
import BasicInformationForm from "./BasicInformationForm";
import {
  clearLocalCacheByModel,
  createPlanStore,
  savePlanDetailsAction,
  setchangeReviewFlag,
  setManagePlanLocalCache,
  setManagePlanToastInfo,
} from "../../../contexts";
import {
  deleteSource,
  getSource,
  listSource,
  saveSource,
} from "../../../services";
import AddToolTip from "../../../components/AddToolTip";
import { setValue } from "@microsoft/applicationinsights-core-js";

const columns = [
  {
    label: "Description",
    className: "column-rules-description",
    columnName: "allocationFormulaDescription",
    link: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_ADD_ADDITIONAL_RULES,
  },
  {
    label: "Effective Start Date",
    className: "column-rule-effectivestartdate",
    columnName: "allocationEffectiveStartDate",
    type: "date",
  },
];

const ManageSourcesNewContainer = (props) => {
  const { state, dispatch } = useContext(createPlanStore);
  const companyId = state?.api?.reviewAndPlanDetail?.companyId;
  // const companyId = 1;
  const { history, location } = props;
  const additionalRulesTableRef = useRef(null);
  const { flow, planId, sourceId } = useRouterParams();
  const formName = managePlanFormNames.BASIC_SOURCES;
  const fields = formFields[formName];
  const intSourceId = parseInt(sourceId, 10);
  const newFlow = sourceId ? FLOW_TYPES.EDIT : "";
  const [data, setData] = useState({});
  const sourcesApiData = get(state, "sources", []);
  const sourcesListData = get(data, "source", []);
  var formValues = sourcesApiData;
  const sourceCategory = get(formValues, "sourceCategory", 0);
  const isDeferral = sourceCategory === SOURCE_CATEGORY_NAME_MAPPING.Deferral;
  const isEmployerDiscretionary =
    sourceCategory === SOURCE_CATEGORY_NAME_MAPPING.Discretionary ||
    sourceCategory === SOURCE_CATEGORY_NAME_MAPPING.NonElectiveRoth;
  const isEmployerMatch =
    sourceCategory === SOURCE_CATEGORY_NAME_MAPPING.Match ||
    sourceCategory === SOURCE_CATEGORY_NAME_MAPPING.MatchRoth;
  const DeleteToastMessage = "You are attempting to delete source.";
  const DeleteToastMessageHead = "Delete Source?";
  const employeeDeferralSource = get(formValues, "employeeDeferralSource", {});
  const employerMatchSource = get(formValues, "employerMatchSource", {});
  const [showWarning, setShowWarning] = useState(false);
  const employerDiscretionarySource = get(
    formValues,
    "employerDiscretionarySource",
    {}
  );
  var additionalAllocationRulesData = isDeferral
    ? get(employeeDeferralSource, "additionalDeferralSource", [])
    : isEmployerMatch
    ? get(employerMatchSource, "additionalMatchSources", [])
    : isEmployerDiscretionary
    ? get(employerDiscretionarySource, "additionalDiscretionarySources", [])
    : [];
  additionalAllocationRulesData = (additionalAllocationRulesData || []).filter(
    (_) => !_.isDeleted
  );

  const [isModalOpen, setIsModalOpen] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");

  const handleClose = () => {
    setIsModalOpen(false);
  };
  const clearCache = () => {
    dispatch(clearLocalCacheByModel("sources"));
  };
  const goBack = () => {
    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES,
        pathParam: [FLOW_TYPES.EDIT, planId],
      })
    );
    clearCache();
  };
  const [dataLoading, setDataLoading] = useState(false);
  useDeepEffect(() => {
    if (formValues?.id !== intSourceId && intSourceId != 0) {
      // setDataLoading(true);
      getSource(intSourceId).then((response) => {
        setData(response);
        setDataLoading(false);
      });
    }
  }, [intSourceId]);
  useDeepEffect(() => {
    if (isEmpty(formValues)) {
      dispatch(
        setManagePlanLocalCache({
          model: "sources",
          data: sourcesListData,
        })
      );
    }
  }, [sourcesListData]);
  const onDeleteClick = () => {
    setShowWarning(true);
  };
  const handleCancelClick = () => {
    setShowWarning(false);
  };
  const handleConfirmClick = () => {
    setShowWarning(false);
    setApiLoading(true);
    deleteSource(intSourceId).then((response) => {
      setApiLoading(false);
      if (!response.isSuccessful) {
        var x = response.errorMessages;
        if (x != null && x[0]?.errorCode !== null && x[0]?.message !== null) {
          setErrorMsg(`${x[0].errorCode} : ${x[0].message}`);
          setIsModalOpen(true);
        }
      } else {
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: `Data deleted successfully`,
          })
        );
        dispatch(
          setchangeReviewFlag({
            module: "sources",
            review: response.isCompleted,
          })
        );
        goBack();
      }
    });
  };

  const buttons = [
    {
      onClick: goBack,
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    // {
    //   link: getPathWithParam({
    //     path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_HISTORY,
    //     pathParam: [flow, planId, sourceId],
    //   }),
    //   label: "History",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   className: "color-black f-1rem",
    // },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: goBack,
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_NEW,
            pathParam: [FLOW_TYPES.SAVE, planId, sourceId],
          })
        ),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: onDeleteClick,
    },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   onClick: onDeleteClick,
    // },
  ];

  const getDataForSave = (values) => {
    const isLastDayRule = get(values, fields.isLastDayRule, false);
    const isHoursRequirement = get(values, fields.isHoursRequirement, false);
    const updatedValues = toApiValue(
      {
        ...formValues,
        ...values,
        id: sourceId || 0,
        sourceCategory: values[fields.sourceCategory] || undefined,
        sourceSubCategory: values[fields.sourceSubCategory] || undefined,

        sourceSubSubCategory: values[fields.sourceSubSubCategory] || undefined,
        //limitMaximum: values[fields.limitMaximum] || null,
        //limitMinimum: values[fields.limitMinimum] || null,
        // maximumDollarCompensation:
        //   values[fields.maximumDollarCompensation] || null,
        rehireDeferralPercentage:
          values[fields.rehireDeferralPercentage] || null,
        [fields.percentageOfCalculation]: getNumber(
          values[fields.percentageOfCalculation]
        ),
        [fields.percentageOfCompensation]: getNumber(
          values[fields.percentageOfCompensation]
        ),
        [fields.enhancedshMatchPercentage]: getNumber(
          values[fields.enhancedshMatchPercentage]
        ),
        [fields.uptoPercentageOfDeferral]: getNumber(
          values[fields.uptoPercentageOfDeferral]
        ),
        isNonPayPeriodApplicable: get(
          values,
          fields.isNonPayPeriodApplicable,
          false
        ),
        isIncludeDefferals: get(values, fields.isIncludeDefferals, null),
        isIncludePlanCompensation: get(
          values,
          fields.isIncludePlanCompensation,
          null
        ),
        isLastDayRule: isLastDayRule,
        isHoursRequirement: isHoursRequirement,
        hours: get(values, fields.hours, false),
        isNormalRetirement:
          !isHoursRequirement && !isLastDayRule
            ? false
            : get(values, fields.isNormalRetirement, false),
        isEarlyRetirement:
          !isHoursRequirement && !isLastDayRule
            ? false
            : get(values, fields.isEarlyRetirement, false),
        isDeath:
          !isHoursRequirement && !isLastDayRule
            ? false
            : get(values, fields.isDeath, false),
        isDisability:
          !isHoursRequirement && !isLastDayRule
            ? false
            : get(values, fields.isDisability, false),
      },
      fields,
      formValues
    );
    if (isEmpty(formValues)) {
      return updatedValues;
    }

    return updatedValues;
  };
  const [apiLoading, setApiLoading] = useState(false);
  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    const d = getDataForSave(values);
    delete d.undefined;
    setApiLoading(true);
    saveSource({ planId: parseInt(planId), ...d }).then((response) => {
      setApiLoading(false);

      if (response.isSuccessful) {
        dispatch(clearLocalCacheByModel("sources"));
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data Saved Successfully",
          })
        );
        dispatch(
          setchangeReviewFlag({
            module: "sources",
            review: response.isCompleted,
          })
        );
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
      } else {
        setSubmitting(false);
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
    });
  };
  const onAdditionalRulesClick = () => {
    if (additionalRulesTableRef.current) {
      additionalRulesTableRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  };
  // const initialValues = {
  //   [fields.isSafeHarbourMatch]: false,
  // };

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  const layoutHeader = sourceId && "Source";
  return (
    <Formik
      initialValues={{
        [fields.isSafeHarbourMatch]: false,
        [fields.isThresholdApplicable]: true,
        //[fields.isMaximumLimitApplicable]: false,

        [fields.contributionType]: get(
          employeeDeferralSource,
          "contributionType",
          []
        ),
        // [fields.safeHarbourType]: null,
        [fields.additionalDeferralSource]: get(
          employeeDeferralSource,
          "additionalDeferralSource",
          []
        ),
        [fields.additionalMatchSources]: get(
          employerMatchSource,
          "additionalMatchSources",
          []
        ),
        [fields.additionalDiscretionarySources]: get(
          employerDiscretionarySource,
          "additionalDiscretionarySources",
          []
        ),
        [fields.isNonPayPeriodApplicable]: false,
        [fields.isEarlyRetirement]: false,
        ...toFormValue(formValues, fields),
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const {
          setFieldValue,
          values,
          handleChange,
          handleSubmit,
          setValues,
          setErrors,
          setFieldError,
          setSubmitting,
          ...rest
        } = formProps;
        const isEmployee = parseInt(values[fields.sourceType], 10) !== 2;
        const isCore = parseInt(values[fields.responsibleMode], 10) === 2;
        const isValidate = parseInt(values[fields.responsibleMode], 10) === 3;
        const isEmployerAdiApplicableDiscretionary =
          parseInt(values[fields.sourceCategory], 10) !==
          SOURCE_CATEGORY_NAME_MAPPING.EmployerOther;

        const hasAdditionalRules =
          parseInt(values[fields.sourceCategory], 10) ===
            SOURCE_CATEGORY_NAME_MAPPING.Deferral ||
          (!isEmployee && isCore && isEmployerAdiApplicableDiscretionary) ||
          (!isEmployee && isValidate && isEmployerAdiApplicableDiscretionary);

        const deleteAdditionalAlloc = () => {
          delete formValues?.employeeDeferralSource?.additionalDeferralSource;
          delete formValues?.employerMatchSource?.additionalMatchSources;
          delete formValues?.employerDiscretionarySource
            ?.additionalDiscretionarySources;
          setValues({
            ...values,
            [fields.additionalDeferralSource]: [],
            [fields.additionalDiscretionarySources]: [],
            [fields.additionalMatchSources]: [],
          });
          additionalAllocationRulesData = [];
        };
        const onAddClick = () => {
          setSubmitting(true);
          // const updatedData = union(sourcesListData, [
          //   toApiValue(values, fields),
          // ]);
          // const updatedData = union(sourcesListData, [
          //   { ...values, id: get(formValues, "id", undefined) },
          // ]);
          let updatedData = [];
          // if (sourceId) {
          //   sourcesListData[sourceId] = {
          //     //...formValues,
          //     ...sourcesListData[sourceId],
          //     ...toApiValue({ ...formValues, ...values }, fields, formValues),
          //   };
          //   updatedData = sourcesListData;
          // } else {
          updatedData = {
            ...sourcesListData,
            ...toApiValue({ ...formValues, ...values }, fields, formValues),
            id: intSourceId || 0,
          };
          // }
          const additionalSourceId = additionalAllocationRulesData.length;
          dispatch(
            setManagePlanLocalCache({
              model: "sources",
              data: updatedData,
            })
          );
          window.setTimeout(() => {
            history.push(
              getAdvancedPathWithParam({
                path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_ADD_ADDITIONAL_RULES,
                pathParam: [flow, planId, intSourceId, additionalSourceId],
              })
            );
          }, 10);
        };

        const onEditAdditionRule = (item, index) => {
          setSubmitting(true);
          let updatedData = [];
          // if (sourceId) {
          //   sourcesListData[sourceId] = {
          //     //...formValues,
          //     ...sourcesListData[sourceId],
          //     ...toApiValue({ ...formValues, ...values }, fields, formValues),
          //   };
          //   updatedData = sourcesListData;
          // } else {
          updatedData = {
            ...sourcesListData,
            ...toApiValue({ ...formValues, ...values }, fields, formValues),
          };

          // }
          dispatch(
            setManagePlanLocalCache({
              model: "sources",
              data: updatedData,
            })
          );
          window.setTimeout(() => {
            history.push(
              getPathWithParam({
                path: item.link,
                pathParam: [flow, planId, intSourceId, index],
              })
            );
          }, 10);
        };

        return (
          <LoaderWrapper isLoading={dataLoading || apiLoading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={rest.submitCount > 0}
            >
              <ManagePlanLayout
                layoutHeader={layoutHeader}
                buttons={buttons}
                pageFlow={flow}
              >
                <div className="d-flex">
                  <div className="plan-heading">Basic Source Information</div>
                  {hasAdditionalRules && (
                    <div className="ml-auto">
                      <Button
                        type="button"
                        variant="link"
                        onClick={onAdditionalRulesClick}
                        className="color-black f-1rem"
                      >
                        Additional Allocation Rules
                      </Button>
                    </div>
                  )}
                </div>
                <Row>
                  <Col>
                    <BasicInformationForm
                      {...formProps}
                      fields={fields}
                      isEdit={isEdit}
                      isSave={isSave}
                      planId={planId}
                      companyId={companyId}
                      hasAdditionalRules={hasAdditionalRules}
                      deleteAdditionalAlloc={deleteAdditionalAlloc}
                    />

                    {values[fields.sourceCategory] != undefined ||
                    values[fields.sourceCategory] != null ? (
                      <>
                        {values[fields.sourceCategory] !=
                          SOURCE_CATEGORY_NAME_MAPPING.EmployerOther && (
                          <div className="line-separator"></div>
                        )}
                        <AllocationRulesForm
                          {...formProps}
                          fields={fields}
                          isEdit={isEdit}
                          isSave={isSave}
                          planId={planId}
                        />
                      </>
                    ) : null}
                    {hasAdditionalRules && (
                      <div
                        className="add-additional-allocation-rules"
                        ref={additionalRulesTableRef}
                      >
                        <Row>
                          <Col>
                            <div className="w-100 bg-white p-3 mt-5">
                              <div className="d-flex align-items-center">
                                <h5 className="m-0">
                                  Additional Allocation Rules
                                </h5>
                                <div className="ml-auto">
                                  <AddButton
                                    menu="plan"
                                    subMenu="sources"
                                    onAddClick={onAddClick}
                                    disabled={isEdit && !isSave}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        {isEmpty(additionalAllocationRulesData) && (
                          <Row className="mt-2">
                            <Col>
                              <AddPlans
                                menu="plan"
                                subMenu="sources"
                                content="No additional allocation rules have been created for this source"
                                buttonLabel="Add Allocation Rule"
                                onPrimaryClick={onAddClick}
                                disabled={isEdit && !isSave}
                              />
                            </Col>
                          </Row>
                        )}
                        {!isEmpty(additionalAllocationRulesData) && (
                          <Row className="mt-2">
                            <Col>
                              <Table>
                                <Table.Thead>
                                  <Table.Tr>
                                    {columns.map((item, index) => {
                                      return (
                                        <Table.Th
                                          key={index}
                                          className={item.className}
                                        >
                                          {item.label}
                                        </Table.Th>
                                      );
                                    })}
                                  </Table.Tr>
                                </Table.Thead>
                                <Table.Tbody>
                                  {additionalAllocationRulesData.map(
                                    (rule, index) => {
                                      return (
                                        <Table.Tr key={index}>
                                          {columns.map((item, cellIndex) => {
                                            return (
                                              <Table.Td
                                                key={cellIndex}
                                                className={item.className}
                                              >
                                                {!isEmpty(item.link) ? (
                                                  rule[item.columnName]
                                                    .length >= 15 ? (
                                                    <OverlayTrigger
                                                      overlay={
                                                        <Tooltip>
                                                          {
                                                            rule[
                                                              item.columnName
                                                            ]
                                                          }
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <Link
                                                        onClick={() =>
                                                          onEditAdditionRule(
                                                            item,
                                                            index
                                                          )
                                                        }
                                                      >
                                                        {rule[
                                                          item.columnName
                                                        ].slice(0, 15) + "..."}
                                                      </Link>
                                                    </OverlayTrigger>
                                                  ) : (
                                                    <Link
                                                      onClick={() =>
                                                        onEditAdditionRule(
                                                          item,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {rule[item.columnName]}
                                                    </Link>
                                                  )
                                                ) : item.type === "date" ? (
                                                  usDateFormat(
                                                    rule[item.columnName]
                                                  )
                                                ) : (
                                                  rule[item.columnName]
                                                )}
                                              </Table.Td>
                                            );
                                          })}
                                        </Table.Tr>
                                      );
                                    }
                                  )}
                                </Table.Tbody>
                              </Table>
                            </Col>
                          </Row>
                        )}
                      </div>
                    )}
                  </Col>
                </Row>

                <DeleteWarning
                  DeleteToastMessageHead={DeleteToastMessageHead}
                  DeleteToastMessage={DeleteToastMessage}
                  showModal={showWarning}
                  handleConfirmClick={handleConfirmClick}
                  handleCancelClick={handleCancelClick}
                />
                <Modal show={isModalOpen} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={handleClose}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        <p>{errorMsg}</p>
                        <br />
                        <Button className="cancel-btn" onClick={handleClose}>
                          Ok
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default ManageSourcesNewContainer;
